import { CheckCircle } from "lucide-react";
import { AnimatedText } from "../components/shared/AnimatedText";
import { AnimatedBlock } from "../components/shared/AnimatedBlock";

export function WhySection({ t }) {
  return (
    <section id="success" className="bg-gray-50 py-20">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-14">
            <AnimatedText text={t.why.title} tag="h2" className="text-4xl md:text-5xl font-black text-blue-900 mb-4" />
            <AnimatedText text={t.why.subtitle} tag="p" delay={80} className="text-gray-700 text-lg max-w-3xl mx-auto" />
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            {t.why.items.map((item, idx) => (
              <AnimatedBlock key={item} delay={idx * 80} className="bg-gray-50 rounded-2xl p-6 shadow-lg border border-gray-100 flex items-start gap-4 hover:shadow-xl transition-shadow">
                <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" />
                <span className="text-gray-800 font-medium leading-relaxed">{item}</span>
              </AnimatedBlock>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
